import { render, staticRenderFns } from "./MinDepartGuarantee.vue?vue&type=template&id=531ab506"
import script from "./MinDepartGuarantee.vue?vue&type=script&lang=js"
export * from "./MinDepartGuarantee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports